import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { UntilDestroy } from '@ngneat/until-destroy';
import { SpdgUserService, UserIdentity } from '@spdg/core';
import { Subscription } from 'rxjs';
import { NotificationPreference } from 'src/app/model/notification-preference.model';
import { ApiUser } from 'src/app/modules/designer/components/table-view/table-view';
import { DesignerSuiteService } from 'src/app/modules/designer/service/designer-suite.service';
import { WorkbenchService } from 'src/app/modules/ecb-workbench/service/workbench.service';
import { ProjectMetaData } from 'src/app/modules/screening-of-activities/soa-constants/types';
import { UserService } from 'src/app/service/user.service';

@UntilDestroy()
@Component({
    selector: 'app-main-layout',
    templateUrl: './main-layout.component.html',
    styleUrls: ['./main-layout.component.scss'],
    standalone: false,
})
export class MainLayoutComponent implements OnInit, OnDestroy {
    // public additionalMenuLinks: SdhHeaderMenuItem[] = [
    //     {
    //         icon: 'circle_help' as RdsIconName,
    //         name: 'Help',
    //         url: import.meta.env.NG_APP_CONTENT_HELP_URL,
    //     },
    //     {
    //         imageSrc: 'assets/gSuite.png',
    //         name: 'gSite',
    //         url: import.meta.env.NG_APP_CONTENT_GSITE_URL,
    //     },
    //     {
    //         action: 'logout',
    //         icon: 'logoff' as RdsIconName,
    //         name: 'Logout',
    //     },
    // ];
    // public avatarInitials = '';
    // public externalLinks = [
    //     { name: 'RocheChat', url: 'https://rochechat.roche.com' },
    //     {
    //         name: 'Help',
    //         url: import.meta.env.NG_APP_CONTENT_HELP_URL,
    //     },
    //     { name: 'gSite', url: import.meta.env.NG_APP_CONTENT_GSITE_URL },
    // ];

    // public landingPageUrl = import.meta.env.NG_APP_LANDING_PAGE_URL;

    private projectDetails!: ProjectMetaData;

    // public logout(): void {
    //     sessionStorage.clear();
    //     this.userService.logout();
    //     window.location.href = this.landingPageUrl +'/login';
    // }

    // onLogoTriggered(): void {
    //     window.location.href = this.landingPageUrl;
    // }

    private readonly subscrition: Subscription[] = [];
    elementName = '';
    scenarioTitle = '';
    subTitle = '';
    title = '';
    isSOA = false;
    showShareButton = false;
    collaboratorCount = 0;
    avatarInitials = '';
    private currentIdentity: UserIdentity | null = null;
    private latestCollaborators: ApiUser[] = [];
    user_role = '';
    constructor(
        public readonly router: Router,
        private readonly workbenchService: WorkbenchService,
        private readonly userService: SpdgUserService,
        private readonly designerService: DesignerSuiteService,
        private readonly appUserService: UserService
    ) {
        this.subscrition.push(
            this.designerService.updateElementTitle.subscribe({
                next: (title: string) => {
                    this.elementName = title;
                },
            })
        );
    }

    ngOnDestroy(): void {
        this.subscrition.forEach((subs) => subs.unsubscribe());
    }

    ngOnInit(): void {
        this.isSOA = globalThis.location.pathname.includes(
            'screening-of-activities'
        );
        const isECB = globalThis.location.pathname.includes('ecb-workbench');
        this.showShareButton = this.isSOA || isECB;
        this.subTitle = this.isSOA
            ? 'Schedule of Activities'
            : 'Eligibility Criteria';
        this.subscrition.push(
            this.userService.userIdentity.subscribe((identity) => {
                this.currentIdentity = identity;
                this.updateAvatarInitials();
            })
        );
        this.subscrition.push(
            this.designerService.eventsProjectMetaData$.subscribe(
                (projectMetaData) => {
                    this.projectDetails = projectMetaData;
                    this.title = this.projectDetails.project_name;
                    this.scenarioTitle = this.projectDetails.scenario_name;
                    this.elementName = this.projectDetails.element_name;
                    this.user_role = this.projectDetails.user_role;
                    this.collaboratorCount =
                        this.projectDetails.collaborators?.length ?? 0;
                    this.latestCollaborators =
                        this.projectDetails.collaborators || [];
                    this.updateAvatarInitials();
                    if (this.projectDetails.notification_preference) {
                        this.appUserService.setNotificationPreference(
                            this.projectDetails
                                .notification_preference as NotificationPreference
                        );
                    }
                }
            )
        );
    }

    onScrollChange() {
        this.workbenchService.onScrollEvent.next('');
    }

    /**
     * Resolve the profile avatar initials from the logged-in identity. Matches
     * this user's own collaborator record by stable identity (sub/email) — never
     * the current_user flag, which a broadcast could point at another user — and
     * uses that record's initials (which include the middle initial). Falls back
     * to first+last from identity when the user isn't in the collaborator list yet.
     */
    private updateAvatarInitials(): void {
        const identity = this.currentIdentity;
        if (!identity) return;

        const own = this.latestCollaborators.find(
            (c) =>
                (!!identity.sub && c.user_id === identity.sub) ||
                (!!identity.email &&
                    c.email?.toLowerCase() === identity.email.toLowerCase())
        );

        const identityInitials =
            (identity.givenName?.slice(0, 1) || '') +
            (identity.lastName?.slice(0, 1) || '');

        this.avatarInitials = own?.initials?.trim() || identityInitials || '';
    }
}
